import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminChat from "@/pages/AdminChat";

export default function AdminChatConsole() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "CHATBOTA — admin";
    if (!localStorage.getItem("vodnice_token")) navigate("/admin");
  }, [navigate]);

  return (
    <div className="bg-void min-h-[100dvh] text-neutral-200">
      <AdminChat standalone />
    </div>
  );
}
